import script from "./AdditionalAttributesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AdditionalAttributesModal.vue?vue&type=script&setup=true&lang=js"

import "./AdditionalAttributesModal.vue?vue&type=style&index=0&id=00a78fa1&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00a78fa1"]])

export default __exports__